import React, { useState } from "react";
import { Link } from "react-router-dom";
import notes from "../data/notes";
import "./Notes.css";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "note", label: "Notes" },
  { key: "doc", label: "Project Docs" },
];

const Notes = () => {
  const [filter, setFilter] = useState("all");

  const visibleNotes =
    filter === "all" ? notes : notes.filter((n) => n.category === filter);

  return (
    <section className="notes-page">
      <div className="notes-container">
        <div className="notes-header">
          <h1>Notes & Project Docs</h1>
          <p className="notes-intro">
            Write-ups on what I'm learning and building — from AI engineering
            concepts to deep-dives on my own projects.
          </p>
        </div>

        <div className="notes-filters">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              className={`notes-filter-btn ${filter === f.key ? "active" : ""}`}
              onClick={() => setFilter(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>

        <div className="notes-grid">
          {visibleNotes.map((note) =>
            note.driveLink ? (
              
               <a href={note.driveLink}
                target="_blank"
                rel="noopener noreferrer"
                key={note.slug}
                className="note-card"
              >
                <span className={`note-badge ${note.category}`}>
                  {note.category === "doc" ? "Project Doc" : "Note"}
                </span>
                <h3>{note.title} ↗</h3>
                <p>{note.summary}</p>
                <div className="note-tags">
                  {note.tags.map((tag) => (
                    <span key={tag} className="note-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </a>
            ) : (
              <Link
                to={`/notes/${note.slug}`}
                key={note.slug}
                className="note-card"
              >
                <span className={`note-badge ${note.category}`}>
                  {note.category === "doc" ? "Project Doc" : "Note"}
                </span>
                <h3>{note.title}</h3>
                <p>{note.summary}</p>
                <div className="note-tags">
                  {note.tags.map((tag) => (
                    <span key={tag} className="note-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </Link>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Notes;